import React, { useMemo } from 'react'

import styled from 'styled-components'

import { Icon } from '_components/icon'
import { IconType } from '_components/icon/helpers'
import { palette } from '_styles/variables'

export const Header = styled.thead`
  background-color: ${palette.neutral['grey-ebebeb']};
  vertical-align: middle;
  width: 100%;
`

const Cell = styled.th`
  & svg {
    color: ${palette.neutral['grey-icons']};
    margin: 0.5625rem 0 0.75rem;
    margin-left: 0.25rem;
  }

  &:first-child button {
    padding-left: 1.25rem;
  }
`

const Wrapper = styled.button<{ isDisabled?: boolean }>`
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  line-height: 2rem;
  text-transform: uppercase;
  font-size: 0.625rem;
  font-weight: 600;
  width: 100%;
  letter-spacing: 0.0313rem;
  padding: 0;
  padding-left: 0.75rem;
`

interface HeaderProps
  extends Omit<React.ComponentPropsWithoutRef<'th'>, 'onClick'> {
  isSorted?: boolean
  isSortedDesc?: boolean
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  isDisabled?: boolean
}

export const HeaderCell: React.FC<HeaderProps> = ({
  children,
  onClick,
  isSorted,
  isSortedDesc,
  isDisabled,
  style,
  ...props
}) => {
  const { icon, label } = useMemo<{ icon: IconType; label: string }>(() => {
    if (!isSorted)
      return {
        icon: 'double-arrow',
        label: `Sort by ${children} in ascending order`,
      }
    if (isSortedDesc)
      return { icon: 'arrow-descending', label: 'Reset sorting' }
    return {
      icon: 'arrow-ascending',
      label: `Sort by ${children} in descending order`,
    }
  }, [isSorted, isSortedDesc, children])
  const newStyle = { ...style }

  if (isDisabled) {
    newStyle.cursor = 'default'
  }

  return (
    <Cell aria-label={label} style={newStyle} {...props}>
      <Wrapper disabled={isDisabled} onClick={onClick}>
        {children}
        <Icon size="0.6875rem" icon={icon} />
      </Wrapper>
    </Cell>
  )
}
